@if (visivel()) {
  <section class="links-acesso-rapido" aria-labelledby="links-acesso-rapido-titulo">
    <h2 class="links-acesso-rapido-titulo" id="links-acesso-rapido-titulo">Acesso rápido</h2>

    <div class="links-acesso-rapido-grade">
      @for (card of cards(); track card.chave) {
        @if (card.destino) {
          <a class="links-acesso-rapido-card" [routerLink]="card.destino">
            <ng-container *ngTemplateOutlet="miolo; context: { $implicit: card }"></ng-container>
          </a>
        } @else {
          <a
            class="links-acesso-rapido-card"
            [href]="card.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ng-container *ngTemplateOutlet="miolo; context: { $implicit: card }"></ng-container>
            <span class="visually-hidden">(abre em nova aba)</span>
          </a>
        }
      }

      <app-links-dinamicos local="Home/Acesso Rápido"></app-links-dinamicos>
    </div>
  </section>
}

<ng-template #miolo let-card>
  <span class="links-acesso-rapido-card-circulo" aria-hidden="true">
    @if (card.imagem) {
      <img class="links-acesso-rapido-card-imagem" [src]="card.imagem" alt="" />
    } @else {
      <i-lucide [name]="card.icone" size="22"></i-lucide>
    }
  </span>

  <span class="links-acesso-rapido-card-conteudo">
    <span class="links-acesso-rapido-card-titulo">{{ card.titulo }}</span>
    <span class="links-acesso-rapido-card-descricao">{{ card.descricao }}</span>
  </span>

  <span
    class="links-acesso-rapido-card-ponto"
    [style.background]="card.cor"
    aria-hidden="true"
  ></span>
</ng-template>
